export default "__VITE_ASSET__Asr9aiaF__";